import LoyaltyList from './loyaltyList.js';
import LoyaltyEdit from './loyaltyEdit.js';
import LoyaltyCreate from './loyaltyCreate.js';


export default {
    list: LoyaltyList,
    edit: LoyaltyEdit,
    create: LoyaltyCreate
}